export const ADD_BOOKING_REQUEST = "ADD_BOOKING_REQUEST";
export const ADD_BOOKING_SUCCESS = "ADD_BOOKING_SUCCESS";
export const ADD_BOOKING_FAILURE = "ADD_BOOKING_FAILURE";
export const ADD_BOOKING_RESET = "ADD_BOOKING_RESET";

export const addBookingRequest = (bookingData: any) => ({
    type: ADD_BOOKING_REQUEST,
    payload: bookingData,
});

export const addBookingReset = () => ({
    type: ADD_BOOKING_RESET,
});

// GET BRANCHES
export const GET_BRANCHES_REQUEST = "GET_BRANCHES_REQUEST";
export const GET_BRANCHES_SUCCESS = "GET_BRANCHES_SUCCESS";
export const GET_BRANCHES_FAILURE = "GET_BRANCHES_FAILURE";

export const getBranchesRequest = () => ({
    type: GET_BRANCHES_REQUEST,
});

// GET CUSTOMER
export const GET_CUSTOMER_REQUEST = "GET_CUSTOMER_REQUEST";
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS";
export const GET_CUSTOMER_FAILURE = "GET_CUSTOMER_FAILURE";

export const CLEAR_CUSTOMER_DATA = "CLEAR_CUSTOMER_DATA";

export const getCustomerRequest = (mobileno: string, cityid: string) => ({
    type: GET_CUSTOMER_REQUEST,
    payload: { mobileno, cityid },
});

export const clearCustomerData = () => ({ type: CLEAR_CUSTOMER_DATA });

// GET VEHICLE TYPES
export const GET_VEHICLE_TYPES_REQUEST = "GET_VEHICLE_TYPES_REQUEST";
export const GET_VEHICLE_TYPES_SUCCESS = "GET_VEHICLE_TYPES_SUCCESS";
export const GET_VEHICLE_TYPES_FAILURE = "GET_VEHICLE_TYPES_FAILURE";

export const getVehicleTypesRequest = (cityid: string) => ({
    type: GET_VEHICLE_TYPES_REQUEST,
    payload: { cityid },
});

// GET TRIP TYPES
export const GET_TRIP_TYPES_REQUEST = "GET_TRIP_TYPES_REQUEST";
export const GET_TRIP_TYPES_SUCCESS = "GET_TRIP_TYPES_SUCCESS";
export const GET_TRIP_TYPES_FAILURE = "GET_TRIP_TYPES_FAILURE";

export const getTripTypesRequest = () => ({
    type: GET_TRIP_TYPES_REQUEST,
});

// GET INTERCITY LIST
export const GET_INTERCITY_LIST_REQUEST = "GET_INTERCITY_LIST_REQUEST";
export const GET_INTERCITY_LIST_SUCCESS = "GET_INTERCITY_LIST_SUCCESS";
export const GET_INTERCITY_LIST_FAILURE = "GET_INTERCITY_LIST_FAILURE";

export const getIntercityListRequest = (vehicleid: string, cityid: string) => ({
    type: GET_INTERCITY_LIST_REQUEST,
    payload: { vehicleid, cityid },
});

// GET RETURN INTERCITY LIST
export const GET_RETURN_INTERCITY_REQUEST = "GET_RETURN_INTERCITY_REQUEST";
export const GET_RETURN_INTERCITY_SUCCESS = "GET_RETURN_INTERCITY_SUCCESS";
export const GET_RETURN_INTERCITY_FAILURE = "GET_RETURN_INTERCITY_FAILURE";

export const getReturnIntercityRequest = () => ({
    type: GET_RETURN_INTERCITY_REQUEST,
});

// GET GOODS TYPES
export const GET_GOODS_TYPES_REQUEST = "GET_GOODS_TYPES_REQUEST";
export const GET_GOODS_TYPES_SUCCESS = "GET_GOODS_TYPES_SUCCESS";
export const GET_GOODS_TYPES_FAILURE = "GET_GOODS_TYPES_FAILURE";

export const getGoodsTypesRequest = () => ({
    type: GET_GOODS_TYPES_REQUEST,
});

// GET LOCATIONS
export const GET_LOCATIONS_REQUEST = "GET_LOCATIONS_REQUEST";
export const GET_LOCATIONS_SUCCESS = "GET_LOCATIONS_SUCCESS";
export const GET_LOCATIONS_FAILURE = "GET_LOCATIONS_FAILURE";

export const getLocationsRequest = (cityid: string) => ({
    type: GET_LOCATIONS_REQUEST,
    payload: { cityid },
});

// GET AVAILABLE CABS
export const GET_AVAILABLE_CABS_REQUEST = "GET_AVAILABLE_CABS_REQUEST";
export const GET_AVAILABLE_CABS_SUCCESS = "GET_AVAILABLE_CABS_SUCCESS";
export const GET_AVAILABLE_CABS_FAILURE = "GET_AVAILABLE_CABS_FAILURE";

export const getAvailableCabsRequest = (
    branchid: string,
    vehicletype: string,
    roleid?: string,
    fromlat?: string,
    fromlong?: string
) => ({
    type: GET_AVAILABLE_CABS_REQUEST,
    payload: { branchid, vehicletype, roleid, fromlat, fromlong },
});

// GET METER FARE
export const GET_METER_FARE_REQUEST = "GET_METER_FARE_REQUEST";
export const GET_METER_FARE_SUCCESS = "GET_METER_FARE_SUCCESS";
export const GET_METER_FARE_FAILURE = "GET_METER_FARE_FAILURE";

export const getMeterFareRequest = (
    distance: string,
    cityid: string,
    vehicleid: string
) => ({
    type: GET_METER_FARE_REQUEST,
    payload: { distance, cityid, vehicleid },
});

// GET PACKAGES
export const GET_PACKAGES_REQUEST = "GET_PACKAGES_REQUEST";
export const GET_PACKAGES_SUCCESS = "GET_PACKAGES_SUCCESS";
export const GET_PACKAGES_FAILURE = "GET_PACKAGES_FAILURE";

export const getPackagesRequest = (
    vehicleid: string,
    cityid: string
) => ({
    type: GET_PACKAGES_REQUEST,
    payload: { vehicleid, cityid },
});

// ADD ENQUIRY
export const ADD_ENQUIRY_REQUEST = "ADD_ENQUIRY_REQUEST";
export const ADD_ENQUIRY_SUCCESS = "ADD_ENQUIRY_SUCCESS";
export const ADD_ENQUIRY_FAILURE = "ADD_ENQUIRY_FAILURE";
export const ADD_ENQUIRY_RESET = "ADD_ENQUIRY_RESET";

export const addEnquiryRequest = (data: any) => ({
    type: ADD_ENQUIRY_REQUEST,
    payload: data,
});

export const addEnquiryReset = () => ({
    type: ADD_ENQUIRY_RESET,
});

export const UPDATE_ENQUIRY_REQUEST = "UPDATE_ENQUIRY_REQUEST";
export const UPDATE_ENQUIRY_SUCCESS = "UPDATE_ENQUIRY_SUCCESS";
export const UPDATE_ENQUIRY_FAILURE = "UPDATE_ENQUIRY_FAILURE";
export const UPDATE_ENQUIRY_RESET = "UPDATE_ENQUIRY_RESET";

export const updateEnquiryRequest = (payload: any) => ({
    type: UPDATE_ENQUIRY_REQUEST,
    payload,
});

export const updateEnquirySuccess = (message: string) => ({
    type: UPDATE_ENQUIRY_SUCCESS,
    payload: { message },
});

export const updateEnquiryFailure = (error: string) => ({
    type: UPDATE_ENQUIRY_FAILURE,
    payload: error,
});

// GET NIGHT FARE
export const GET_NIGHT_FARE_REQUEST = "GET_NIGHT_FARE_REQUEST";
export const GET_NIGHT_FARE_SUCCESS = "GET_NIGHT_FARE_SUCCESS";
export const GET_NIGHT_FARE_FAILURE = "GET_NIGHT_FARE_FAILURE";

export const getNightFareRequest = (
    vehicleid: string,
    cityid: string
) => ({
    type: GET_NIGHT_FARE_REQUEST,
    payload: { vehicleid, cityid },
});

// GET ENQUIRY BY DATE
export const GET_ENQUIRY_BY_DATE_REQUEST = "GET_ENQUIRY_BY_DATE_REQUEST";
export const GET_ENQUIRY_BY_DATE_SUCCESS = "GET_ENQUIRY_BY_DATE_SUCCESS";
export const GET_ENQUIRY_BY_DATE_FAILURE = "GET_ENQUIRY_BY_DATE_FAILURE";

export const getEnquiryByDateRequest = (branchid: string, fromdate: string, todate: string) => ({
    type: GET_ENQUIRY_BY_DATE_REQUEST,
    payload: { branchid, fromdate, todate },
});

// ENQUIRY TO NEW BOOKING
export const ENQUIRY_TO_NEW_BOOKING_REQUEST = "ENQUIRY_TO_NEW_BOOKING_REQUEST";
export const ENQUIRY_TO_NEW_BOOKING_SUCCESS = "ENQUIRY_TO_NEW_BOOKING_SUCCESS";
export const ENQUIRY_TO_NEW_BOOKING_FAILURE = "ENQUIRY_TO_NEW_BOOKING_FAILURE";
export const ENQUIRY_TO_NEW_BOOKING_RESET = "ENQUIRY_TO_NEW_BOOKING_RESET";

export const enquiryToNewBookingRequest = (data: any) => ({
    type: ENQUIRY_TO_NEW_BOOKING_REQUEST,
    payload: data,
});

export const enquiryToNewBookingReset = () => ({
    type: ENQUIRY_TO_NEW_BOOKING_RESET,
});

// ENQUIRY ASSIGN TRIP
export const ENQUIRY_ASSIGN_TRIP_REQUEST = "ENQUIRY_ASSIGN_TRIP_REQUEST";
export const ENQUIRY_ASSIGN_TRIP_SUCCESS = "ENQUIRY_ASSIGN_TRIP_SUCCESS";
export const ENQUIRY_ASSIGN_TRIP_FAILURE = "ENQUIRY_ASSIGN_TRIP_FAILURE";
export const ENQUIRY_ASSIGN_TRIP_RESET = "ENQUIRY_ASSIGN_TRIP_RESET";

export const enquiryAssignTripRequest = (data: any) => ({
    type: ENQUIRY_ASSIGN_TRIP_REQUEST,
    payload: data,
});

export const enquiryAssignTripReset = () => ({
    type: ENQUIRY_ASSIGN_TRIP_RESET,
});

// GET DISTANCE
export const GET_DISTANCE_REQUEST = "GET_DISTANCE_REQUEST";
export const GET_DISTANCE_SUCCESS = "GET_DISTANCE_SUCCESS";
export const GET_DISTANCE_FAILURE = "GET_DISTANCE_FAILURE";

export const LONG_TRIP_KM = 15;

export const getDistanceRequest = (
    fromlat: string,
    fromlong: string,
    tolat: string,
    tolong: string,
    cityid: string,
    vehicleid: string,
    faretype?: number,
    applyLongTripRule?: boolean
) => ({
    type: GET_DISTANCE_REQUEST,
    payload: {
        fromlat, fromlong, tolat, tolong, cityid, vehicleid, faretype,
        applyLongTripRule,
    },
});

// RESET FARE ESTIMATE
export const RESET_FARE_ESTIMATE = "RESET_FARE_ESTIMATE";
export const resetFareEstimate = () => ({
    type: RESET_FARE_ESTIMATE,
});

// GET COMPANIES
export const GET_COMPANIES_REQUEST = "GET_COMPANIES_REQUEST";
export const GET_COMPANIES_SUCCESS = "GET_COMPANIES_SUCCESS";
export const GET_COMPANIES_FAILURE = "GET_COMPANIES_FAILURE";

export const getCompaniesRequest = (cityid: string) => ({
    type: GET_COMPANIES_REQUEST,
    payload: { cityid },
});

// GET NEW BOOKING EDIT
export const GET_NEW_BOOKING_EDIT_REQUEST = "GET_NEW_BOOKING_EDIT_REQUEST";
export const GET_NEW_BOOKING_EDIT_SUCCESS = "GET_NEW_BOOKING_EDIT_SUCCESS";
export const GET_NEW_BOOKING_EDIT_FAILURE = "GET_NEW_BOOKING_EDIT_FAILURE";
export const GET_NEW_BOOKING_EDIT_RESET = "GET_NEW_BOOKING_EDIT_RESET";

export const getNewBookingEditRequest = (bookingid: string) => ({
    type: GET_NEW_BOOKING_EDIT_REQUEST,
    payload: { bookingid },
});

export const getNewBookingEditReset = () => ({
    type: GET_NEW_BOOKING_EDIT_RESET,
});

// CLEAR FARE LISTS
export const CLEAR_FARE_LISTS = "CLEAR_FARE_LISTS";
export const clearFareLists = () => ({
    type: CLEAR_FARE_LISTS,
});